import { render } from "./YourScheduleToday.vue?vue&type=template&id=fedcb318&ts=true"
import script from "./YourScheduleToday.vue?vue&type=script&lang=ts"
export * from "./YourScheduleToday.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__